export default __webpack_public_path__ + "static/media/logo.e56188e9.svg";